import type { IconProps } from "rivals/components/shared/Icons/iconPropsTypes";

function X({ style }: IconProps): JSX.Element {
  return (
    <svg
      fill="none"
      height="31"
      style={style}
      viewBox="0 0 30 31"
      width="30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7981_7679)">
        <circle
          cx="15"
          cy="15.5"
          fill="white"
          r="14.75"
          stroke="#9C9C9C"
          strokeWidth="0.5"
        />
        <g clipPath="url(#clip1_7981_7679)">
          <path
            d="M16.427 14.5069L22.0111 8H20.6879L15.8392 13.6499L11.9666 8H7.5L13.3562 16.5436L7.5 23.3671H8.82333L13.9436 17.4007L18.0334 23.3671H22.5L16.4267 14.5069H16.427ZM14.6146 16.6189L14.0212 15.7681L9.30014 8.99862H11.3327L15.1427 14.4618L15.736 15.3126L20.6885 22.4139H18.656L14.6146 16.6192V16.6189Z"
            fill="black"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_7981_7679">
          <rect
            fill="white"
            height="30"
            transform="translate(0 0.5)"
            width="30"
          />
        </clipPath>
        <clipPath id="clip1_7981_7679">
          <rect
            fill="white"
            height="15.375"
            transform="translate(7.5 8)"
            width="15"
          />
        </clipPath>
      </defs>
      <title>X Circled</title>
    </svg>
  );
}

export default X;
